module.exports = __webpack_public_path__ + "static/schedule-452c1838e32ed21a21ffdbc484e92f95.mp4";